/**
 * TripStatusBadge — compact status pill for trip list and detail headers.
 */
import styled from "styled-components";
import { TRIP_STATUS_LABELS } from "../constants/tripStatuses.js";

const STATUS_STYLES = {
  accepting_load: { bg: "#f0fdf4", color: "#15803d", border: "#bbf7d0" },
  planned: { bg: "#ecfdf5", color: "#047857", border: "#a7f3d0" },
  loaded: { bg: "#eff6ff", color: "#1d4ed8", border: "#bfdbfe" },
  en_route: { bg: "#fffbeb", color: "#b45309", border: "#fde68a" },
  completed: { bg: "#f3f4f6", color: "#374151", border: "#e5e7eb" },
};

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  border: 1px solid ${({ $styles }) => $styles.border};
  background: ${({ $styles }) => $styles.bg};
  color: ${({ $styles }) => $styles.color};
  white-space: nowrap;
`;

const TripStatusBadge = ({ status, size = "small" }) => {
  const normalized = status || "planned";
  const styles = STATUS_STYLES[normalized] || STATUS_STYLES.planned;
  const label =
    TRIP_STATUS_LABELS[normalized] ||
    normalized.replace("_", " ").toUpperCase();

  return (
    <Badge $styles={styles} $size={size} data-testid="trip-status-badge">
      {label}
    </Badge>
  );
};

export default TripStatusBadge;
